const currencyFormatter = (num: number) => {
  const formattor = new Intl.NumberFormat("en-IN", {
    maximumSignificantDigits: 3,
  });
  return `Rs. ${formattor.format(num)}`;
};
export default currencyFormatter;
